import UserSection from '@src/components/layout/admin/sections/users';
export default function UsersPage() {
    return <UserSection title={'รายชื่อผู้ใช้งาน'} />;
}
